export const defaultAppConfigMessage =
  'Deploy the application using the exact configuration defined in the selected template.'
export const customAppConfigMessage =
  'Customize VM resources and request more CPU, Memory or Storage for your new app.'

export const vmImagePath = '/ui/images/vms-logo.svg'
export const cpuImagePath = '/ui/images/microchip-solid-logo.svg'
export const memoryImagePath = '/ui/images/microchip-solid.svg'
export const storageImagePath = '/ui/images/storage-logo.svg'
export const defaultAppIconPath = '/ui/images/default-app-icon.svg'

export const disabledCreateAppAdminMessage = 'No templates available, please create a template.'
export const disabledCreateAppSSUUserMessage =
  'No templates available, please contact your admin to create templates.'
